import { warn } from 'helper/debug';
import i18n from 'helper/i18n';
import moment, { Moment } from 'moment';

export type PARSE_FORMATS_Type = {
	DATE: string;
	TIME: string;
	DATE_TIME: string;
};

export type DISPLAY_FORMATS_Type = {
	DATE: string;
	TIME: string;
	DATE_TIME: string;
	SHORT_DATE: string;
	WEEKDAY: string;
	WEEKDAY_SHORT: string;
};

export const PARSE_FORMATS: PARSE_FORMATS_Type = {
	DATE: 'YYYY-MM-DD',
	TIME: 'HH:mm',
	DATE_TIME: 'YYYY-MM-DD HH:mm',
};

export const DISPLAY_FORMATS: DISPLAY_FORMATS_Type = {
	DATE: 'date',
	TIME: 'time',
	DATE_TIME: 'dateTime',
	SHORT_DATE: 'shortDate',
	WEEKDAY: 'weekday',
	WEEKDAY_SHORT: 'weekdayShort',
};

export const format = (
	value: string | number | Date,
	displayFormat: string = DISPLAY_FORMATS.DATE,
	parseFormat: string = PARSE_FORMATS.DATE
): string => {
	const theMoment = moment(value, parseFormat);
	if (typeof value !== 'string' || value === '' || !theMoment.isValid()) {
		warn(`Invalid date provided: ${value}`, theMoment.invalidAt());
		return value.toString();
	}

	switch (displayFormat) {
		case DISPLAY_FORMATS.DATE:
			return theMoment.format(i18n('react.impulsCoach.format.date'));
		case DISPLAY_FORMATS.TIME:
			return theMoment.format(i18n('react.impulsCoach.format.time'));
		case DISPLAY_FORMATS.SHORT_DATE:
			return theMoment.format(i18n('react.impulsCoach.format.shortDate'));
		case DISPLAY_FORMATS.WEEKDAY:
			return theMoment.format(i18n('react.impulsCoach.format.weekday'));
		case DISPLAY_FORMATS.WEEKDAY_SHORT:
			return theMoment.format(i18n('react.impulsCoach.format.weekdayShort'));
		default:
			return theMoment.format(i18n('react.impulsCoach.format.dateTime'));
	}
};

export const isAfterNow = (date: Date, parseFormat: string = ''): boolean => {
	const theMoment = moment(date, parseFormat);
	return moment().isBefore(theMoment);
};

export const isWithin5Seconds = (date: Date, parseFormat: string = ''): boolean => {
	const theMoment = moment(date, parseFormat);
	return moment().diff(theMoment, 'seconds') <= 5;
};

export const isWithinNHours = (date: Date, hours: number, parseFormat: string = ''): boolean => {
	const theMoment = moment(date, parseFormat);
	return moment().diff(theMoment, 'hours') <= hours;
};

export const diff = (date: Date, unit: 'hours' | 'seconds' | 'minutes', parseFormat: string = ''): number => {
	const theMoment = moment(date, parseFormat);
	return moment().diff(theMoment, unit);
};

export const isBeforeDate = (
	dateOne: string | Moment,
	dateTwo: string | Moment,
	parseFormat: string = i18n('react.impulsCoach.format.date')
): boolean => {
	const one = moment(dateOne, parseFormat);
	const two = moment(dateTwo, parseFormat);
	return one.isBefore(two);
};

export const toUnix = (date: Date, parseFormat: string = i18n('react.impulsCoach.format.date')): number => {
	return moment(date, parseFormat).unix();
};
